import React, { useContext } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { IoMdCheckmark } from 'react-icons/io';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../HomePage/Components/Header';
import { AuthContext } from '../../Context/authContext';
import { Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import { makeStyles } from '@mui/styles';
import { FormContext } from '../../Context/formContext';

const useStyles = makeStyles((theme) => ({
  subTitleTypo: {
    opacity: '50%',
    color: '#000000',
    fontSize: 11,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subDescriptionTypo: {
    color: '#000000',
    fontSize: 16,
    fontWeight: 500,
  },
}));

const EventsDetails = () => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();
  const {
    state: { user },
  } = useContext(AuthContext);
  const { formState, formDispatch } = useContext(FormContext);

  const goToApplicationForm = () => {
    formDispatch({
      type: 'new',
      payload: {
        programDetails: { ...location?.state, formId: location?.state?.formId },
      },
    });
    navigate({
      pathname: '/application',
      search: `?formId=${location?.state?.formId}&type=${location?.state?.departmentName}`,
    });
  };

  return (
    <Box>
      <Header
        Heading={
          <h1 className="font-black-24-normal w-100 ">
            👋 Hello,{' '}
            <b className="font-black-24-superbold">{user?.applicantName}</b>
          </h1>
        }
        divider={true}
      />
      <Box component={'div'} className="PageContainer w-100">
        <img
          src={location?.state?.program?.bannerImage}
          alt="EventImg"
          className="w-100"
          height={'330px'}
          style={{ objectFit: 'cover' }}
        />
        <Box component={'div'} padding={'32px 32px'}>
          <div className="d-flex justify-content-between align-items-start">
            <div className="d-flex gap-3">
              <Box
                component={'div'}
                className="border px-2 rounded-2 text-center"
              >
                <h2 className="font-black-40-bold">
                  {moment(location?.state?.program?.startDateTime).format('DD')}
                </h2>
                <h2 className="font-black-12-bold text-uppercase">
                  {moment(location?.state?.program?.startDateTime).format(
                    'MMM'
                  )}
                </h2>
              </Box>
              <div>
                <h2 className="font-black-36-bold text-capitalize">
                  {location?.state?.EventName}
                </h2>
                <main className="font-grey-20-normal">
                  {location?.state?.program?.title}
                </main>
              </div>
            </div>
            <div className="d-flex gap-4 align-items-center">
              <h2 className="font-grey-18-bold">
                <i>
                  Apply before{' '}
                  <b className="font-black-18-bold">
                    {moment(location?.state?.endDate).format('DD MMM, YYYY')}
                  </b>
                </i>
              </h2>
              <button
                className="primary-contained-button rounded-2 px-2 py-2"
                onClick={() => goToApplicationForm()}
              >
                Apply Now
              </button>
            </div>
          </div>
        </Box>
        <Box
          border={'2px solid #F1F5F8'}
          height={'2px'}
          marginLeft={'32px'}
        ></Box>
        <Grid container spacing={4} margin={'-12px -4px 16px 0px'}>
          <Grid item>
            <Typography className={classes.subTitleTypo}>
              Date & Time
            </Typography>
            <Typography className={classes.subDescriptionTypo}>
              {moment(location?.state?.program?.startDateTime).format(
                'DD MMM YYYY'
              )}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subTitleTypo}>SECTOR</Typography>
            <Typography className={classes.subDescriptionTypo}>
              {location?.state?.program?.type}
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subTitleTypo}>DURATION</Typography>
            <Typography className={classes.subDescriptionTypo}>
              {moment(location?.state?.program?.endDateTime).diff(
                moment(location?.state?.program?.startDateTime),
                'days'
              )}{' '}
              Day
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subTitleTypo}>LOCATION</Typography>

            {location?.state?.program?.mode == 'On-Site' ? (
              //   <Tooltip title={location?.state?.program?.location}>
              <Typography
                className={classes.subDescriptionTypo}
                //   sx={{
                //     width: '150px',
                //     whiteSpace: 'nowrap',
                //     overflow: 'hidden',
                //     textOverflow: 'ellipsis',
                //     fontWeight: 500,
                //   }}
              >
                {location?.state?.program?.location}
              </Typography>
            ) : (
              //   </Tooltip>
              <Typography
                className={classes.subDescriptionTypo}
                //   sx={{
                //     width: '150px',
                //     whiteSpace: 'nowrap',
                //     overflow: 'hidden',
                //     textOverflow: 'ellipsis',
                //     fontWeight: 500,
                //   }}
              >
                {location?.state?.program?.mode}
              </Typography>
            )}
          </Grid>
          <Grid item>
            <Typography className={classes.subTitleTypo}>CATEGORIES</Typography>
            <Grid item container spacing={2} sx={{ marginTop: '-12px' }}>
              {location?.state?.program?.category?.split(';')?.map((el) => {
                return (
                  <Grid item>
                    <Typography
                      border={'1px solid grey'}
                      className={classes.subDescriptionTypo}
                      fontSize={'12px !important'}
                      borderRadius={'4px'}
                      paddingRight={'2px'}
                      paddingLeft={'2px'}
                    >
                      {el}
                    </Typography>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
        </Grid>
        <Box
          border={'2px solid #F1F5F8'}
          height={'2px'}
          marginLeft={'32px'}
        ></Box>{' '}
        <Box padding={'32px 32px'}>
          <Grid container spacing={3}>
            <Grid item md={6}>
              <div>
                <h2 className="font-black-18-bold">ABOUT THE PROGRAM</h2>
                <Box
                  component={'div'}
                  className="font-black-16-thin mt-3"
                  textAlign={'justify'}
                >
                  {location?.state?.program?.description}
                </Box>
              </div>
            </Grid>
            <Grid item md={6}>
              <Box component={'div'} paddingLeft={'100px'}>
                <h2 className="font-black-18-bold mb-3">WHAT TO EXPECT</h2>
                {/* {[1, 2, 3, 4].map((item, index) => (
                  <div key={item} className="d-flex mt-2">
                    <IoMdCheckmark
                      color="#07588F"
                      className="font-primary-20-bold"
                    />
                    <main className="font-black-16-normal mx-4">
                      {}
                    </main>
                  </div>
                ))} */}
                <div
                  dangerouslySetInnerHTML={{
                    __html: location?.state?.program?.secondaryDescription,
                  }}
                ></div>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default EventsDetails;
